import vue from "vue";

export const fetchHealthCareList = async (market) => {
 
  const res = await vue.axios.get(`/catalog/api/item/filter?market=${market}`);
  return res.data
}
